






























import Vue from 'vue';
import RiskBox from 'common/components/ui/RiskBox/index.vue';
import commonClient from '../../../../common/apis';

export default Vue.extend({
  components: {
    RiskBox,
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      hideBox: true,
      isHoverTrash: false,
      showDeleteBox: false,
    };
  },
  methods: {
    confirmDelete() {
      commonClient.deleteWxTplTemplate({
        id: this.template.id,
      });
      this.$store.commit('DELETE_WX_TPL_TEMPLATE', this.template.id);
      this.showDeleteBox = false;
    },
    mouseOver() {
      this.hideBox = false;
    },
    mouseOut() {
      this.hideBox = true;
    },
  },
});
